import React, { useState } from "react";

import opacity from "hex-color-opacity";

import { useTheme } from "@fartherfinance/frontend/theme/ThemeProvider";

import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./TwoTextItemToggle.module.css";

interface Props {
  leftOption: string;
  rightOption: string;
  value: "Left" | "Right";
  onChange: (option: "Left" | "Right") => void;
  className?: string;
  selectedClassName?: string;
  selectedTextClassName?: string;
}

function TwoTextItemToggle(props: Props): JSX.Element {
  const [curHoverOption, setCurHoverOption] = useState<
    "Left" | "Right" | "None"
  >("None");

  const {
    color: { $backgroundDisabled },
  } = useTheme();

  const clickOption = (option: "Left" | "Right") => {
    if (option === props.value) {
      return;
    }

    props.onChange(option);
  };

  return (
    <div className={toClassName(styles.container, props.className)}>
      <div
        className={styles.leftOptionContainer}
        style={
          curHoverOption === "Left"
            ? {
                backgroundColor: opacity($backgroundDisabled, 0.3),
              }
            : {}
        }
        onClick={() => clickOption("Left")}
      >
        <p
          className={toClassName(styles.optionTextLeft, {
            [props.selectedTextClassName ?? ""]: props.value === "Left",
          })}
          onMouseEnter={() => setCurHoverOption("Left")}
          onMouseLeave={() => setCurHoverOption("None")}
        >
          {props.leftOption}
        </p>

        <div
          className={toClassName(styles.leftOption, {
            [styles.optionSelected]: props.value === "Left",
            [props.selectedClassName ?? ""]: props.value === "Left",
          })}
          onMouseEnter={() => setCurHoverOption("Left")}
          onMouseLeave={() => setCurHoverOption("None")}
        />
      </div>

      <div
        className={styles.rightOptionContainer}
        style={
          curHoverOption === "Right"
            ? {
                backgroundColor: opacity($backgroundDisabled, 0.3),
              }
            : {}
        }
        onClick={() => clickOption("Right")}
      >
        <p
          className={toClassName(styles.optionTextRight, {
            [props.selectedTextClassName ?? ""]: props.value === "Right",
          })}
          onMouseEnter={() => setCurHoverOption("Right")}
          onMouseLeave={() => setCurHoverOption("None")}
        >
          {props.rightOption}
        </p>

        <div
          className={toClassName(styles.rightOption, {
            [styles.optionSelected]: props.value === "Right",
            [props.selectedClassName ?? ""]: props.value === "Right",
          })}
          onMouseEnter={() => setCurHoverOption("Right")}
          onMouseLeave={() => setCurHoverOption("None")}
        />
      </div>
    </div>
  );
}

export default TwoTextItemToggle;
